import { combineReducers } from 'redux'
import { reducer as formReducer } from 'redux-form'
import signin from '../services/signin/reducer'
import signup from '../services/signup/reducer'
import crypto from '../services/crypto/reducer'
import note from '../services/note/reducer'
import notes from '../services/notes/reducer'

export default combineReducers({
  signin,
  signup,
  crypto,
  note,
  notes,
  form: formReducer
})



// WEBPACK FOOTER //
// ./src/redux/reducer.js